export default __webpack_public_path__ + "media/images/logos/plus-divide-orange-plus-b246873a092d8fe4bf70e30505bf882d.svg";